
<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>RVT/KMZ Import Trajectories</h2>
      <div class="close" (click)="cancelTrajectories()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngTrajectoriesForm" #ngForm="ngForm" id="trajectoriesForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>File Source</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File Name</label>
                  <input
                  style="padding-left: 0px;"
                  maxlength="300"
                  type="file"
                  name="filename"
                  id="filename"
                  #uploadCsvFile
                />
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Settings</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Procedure</label>
                  <select name="Procedure" id="procedure" >
                    <option value="New Procedure">New Procedure</option>
                    <option value="111">111</option>
                  </select>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Procedure Identifier</label>
                  <input type="text" />
                </div>
                <div>
                  <label for="">Procedure Name</label>
                  <input type="text" />
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Procedure Type</label>
                  <select name="Procedure Type" id="procedureType" >
                    <option value="SID">SID</option>
                    <option value="STAR">STAR</option>
                    <option value="EN-ROUTE">EN-ROUTE</option>
                  </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">RNAV Performance Type</label>
                  <select name="RNAV Performance Type" id="rnavPerformanceType" >
                    <option value="RNAV-5 (B-RNAV)">RNAV-5 (B-RNAV)</option>
                    <option value="RNAV-1 (P-RNAV)">RNAV-1 (P-RNAV)</option>
                    <option value="A-RNP">A-RNP</option>
                  </select>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Trajectory Name</label>
                  <input type="text" />
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid">
              OK
            </button>
            <button class="gray" (click)="cancelTrajectories()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
